import apiClient from './client';

export const analyticsApi = {
  getOverview(params = {}) {
    return apiClient.get('/analytics/overview', params);
  },

  getTraffic(params = {}) {
    return apiClient.get('/analytics/traffic', params);
  },

  getPages(params = {}) {
    return apiClient.get('/analytics/pages', params);
  },

  getSources(params = {}) {
    return apiClient.get('/analytics/sources', params);
  },

  getDevices(params = {}) {
    return apiClient.get('/analytics/devices', params);
  },

  getGeo(params = {}) {
    return apiClient.get('/analytics/geo', params);
  },

  // Enhanced analytics endpoints
  getLandingPages(params = {}) {
    return apiClient.get('/analytics/landing-pages', params);
  },

  getExitPages(params = {}) {
    return apiClient.get('/analytics/exit-pages', params);
  },

  getStickiness(params = {}) {
    return apiClient.get('/analytics/stickiness', params);
  },

  getHourlyActivity(params = {}) {
    return apiClient.get('/analytics/hourly-activity', params);
  },

  getSearchKeywords(params = {}) {
    return apiClient.get('/analytics/search-keywords', params);
  },

  // Reports endpoints
  getReportsOverview(params = {}) {
    return apiClient.get('/analytics/reports/overview', params);
  },

  getReportsByChannel(params = {}) {
    return apiClient.get('/analytics/reports/by-channel', params);
  },

  getReportsByAdvertiser(params = {}) {
    return apiClient.get('/analytics/reports/by-advertiser', params);
  },

  getReportsBySite(params = {}) {
    return apiClient.get('/analytics/reports/by-site', params);
  },

  getReportsByCampaign(params = {}) {
    return apiClient.get('/analytics/reports/by-campaign', params);
  },

  getReportsByCampaignDetailed(params = {}) {
    return apiClient.get('/analytics/reports/by-campaign-detailed', params);
  },

  getReportsByZone(params = {}) {
    return apiClient.get('/analytics/reports/by-zone', params);
  },

  getReportsByAd(params = {}) {
    return apiClient.get('/analytics/reports/by-ad', params);
  },

  getReportsByAdDetailed(params = {}) {
    return apiClient.get('/analytics/reports/by-ad-detailed', params);
  },

  // Daily breakdown endpoints
  getDailyTrend(params = {}) {
    return apiClient.get('/analytics/reports/daily-trend', params);
  },

  getCampaignDaily(params = {}) {
    return apiClient.get('/analytics/reports/by-campaign-daily', params);
  },

  getZoneDaily(params = {}) {
    return apiClient.get('/analytics/reports/by-zone-daily', params);
  },

  getAdDaily(params = {}) {
    return apiClient.get('/analytics/reports/by-ad-daily', params);
  },
};

export default analyticsApi;
